/**
 * 404.
 *
 * Usava `<a href="/">`, que RECARREGA o app inteiro pra fazer o que o router faz
 * de graça — e com a raiz roteando por papel, era um round-trip completo
 * (bundle, sessão, consulta de papel) só pra chegar onde o `<Link>` chega na hora.
 *
 * O destino também deixou de ser a raiz genérica: quem erra a URL volta pra CASA
 * DELE. Aluno não cai no console, superadmin não cai no catálogo.
 *
 * ⚠️ Esta tela é COMPARTILHADA com o 12brain Academy, cujo produto é em inglês —
 * por isso o texto não foi traduzido junto com o modo classe. Se ela precisar
 * falar português no NEXTGEN, o caminho é o `react-intl` que já existe no
 * projeto, não uma string trocada na mão.
 */
import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { usePapel, homeDoPapel } from "@/hooks/usePapel";
import { ALUNO_ENTRA_PELA_SALA } from "@/branding/identidade";
import { FIXED_BRAND_ID } from "@/branding/product";

const NotFound = () => {
  const location = useLocation();
  const { papel } = usePapel();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <Link to={homeDoPapel(papel, ALUNO_ENTRA_PELA_SALA.has(FIXED_BRAND_ID ?? ''))} className="text-primary underline hover:text-primary/90">
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
